import { autoserialize } from 'cerialize';

export class LyftDispatchRideFareReviewStatusUpdate {
  @autoserialize
  status: string;

  @autoserialize
  lyftDispatchRideId: number;

  @autoserialize
  lyftDispatchRideFareAdjustmentReasonId: number;

  @autoserialize
  requestDescription: string;
}
